import { AllocationsPage } from './AllocationsPage';

export function MultiAllocatedPage() {
  return <AllocationsPage multiAllocated />;
}
